module.exports = __webpack_public_path__ + "img/main_menu_hover_2.58402d37.png";